import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { dashboardService } from './common.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'quickpay';
  environmentName = '';
  environmentUrl = 'Debug api';

  constructor(private dashboardservice: dashboardService) {
    this.environmentName = environment.environmentName;
    this.environmentUrl = environment.apiUrl;
  }

  ngOnInit() {
  }
}
